import { Select } from 'antd';
import styled from 'styled-components';

export default styled(Select)`
	// Add your styles here
`;

export const SelectFontSizeLG = styled(Select)`
	.ant-select-selector {
		font-size: 16px;
	}

	&.ant-select-multiple .ant-select-selection-overflow-item-rest .ant-select-selection-item {
		background-color: ${(props) => props.$tagColor || '#1677ff'} !important;
		color: #fff !important;
		border: none !important;
	}

	&.ant-select-multiple .ant-select-selection-overflow-item-rest .ant-select-selection-item-content {
		color: #fff !important;
	}
`;
